<template>
  <Btn :label="$t('ELE0527')" icon="mdi-paperclip" @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnAttach',

  components: {
    Btn,
  },

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
